const awsRumSessionAttribute = {
    VERSION: 'applicationVersion',
    MARKET: 'market',
    USER: 'user',
    STORE: 'store',
    USER_AGENT: 'user_agent',
    ENV: 'env',
};

export default awsRumSessionAttribute;
